/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FragmentNames {
  ACCOUNT_CREATE_NEW_PASSWORD = 'account-create-new-password',
  ACCOUNT_CREATE_NEW_PASSWORD_FAIL = 'account-create-new-password-fail',
  ACCOUNT_CREATE_NEW_PASSWORD_SUCCESS = 'account-create-new-password-success',
  ACCOUNT_CREATION_COMPLETED = 'account-creation-completed',
  ACCOUNT_CREATION_MODAL = 'account-creation-modal',
  ACCOUNT_CREATION_PRIVACY_MODAL = 'account-creation-privacy-modal',
  ACCOUNT_CREATION_PROCESSING = 'account-creation-processing',
  ACCOUNT_CREATION_STEPS = 'account-creation-steps',
  ACCOUNT_CREATION_TERMS_MODAL = 'account-creation-terms-modal',
  APP = 'app',
  ASSIGN_PRIVACY_MODAL = 'assign-privacy-modal',
  ASSIGN_TERMS_OF_USE_MODAL = 'assign-terms-of-use-modal',
  CHANGE_EXPIRED_PASSWORD = 'change-expired-password',
  CHANGE_PASSWORD = 'change-password',
  DASHBOARD = 'dashboard',
  EXAM_DETAILS = 'exam-details',
  EXAM_LAB_DETAILS = 'exam-lab-details',
  EXAM_RESULTS = 'exam-results',
  FOOTER = 'footer',
  FORGET_PASSWORD = 'forget-password',
  FORGET_PASSWORD_REQUEST_EMAIL_NOT_FOUND = 'forget-password-request-email-not-found',
  FORGET_PASSWORD_REQUEST_FAILURE = 'forget-password-request-failure',
  FORGET_PASSWORD_REQUEST_SUCCESS = 'forget-password-request-success',
  LOGIN = 'login',
  LOGOUT_INACTIVITY = 'logout-inactivity',
  MODAL_ACTIVE = 'modal-active',
  MODAL_WARNING_EXPIRATION_PASSWORD = 'modal-warning-expiration-password',
  NEW_USER_BY_LOGIN = 'new-user-by-login',
  NEW_USER_BY_LOGIN_COMPLETED = 'new-user-by-login-completed',
  NEW_USER_BY_LOGIN_MODAL = 'new-user-by-login-modal',
  NEW_USER_BY_LOGIN_PROCESSING = 'new-user-by-login-processing',
  NEW_USER_BY_LOGIN_STEPS = 'new-user-by-login-steps',
  NEW_USER_PERSONAL_INFORMATION = 'new-user-personal-information',
  NEW_USER_PRE_REGISTRATION = 'new-user-pre-registration',
  NEW_USER_STEPS = 'new-user-steps',
  PASSWORD_RESET = 'password-reset',
  PATIENTS_LIST = 'patients-list',
  PERSONAL_ADDITIONAL = 'personal-additional',
  PERSONAL_INFORMATION = 'personal-information',
  PRIVACY_AND_TERMS_MODAL = 'privacy-and-terms-modal',
  PRIVACY_MODAL = 'privacy-modal',
  PROFILE = 'profile',
  PROFILE_PRIVACY_AND_TERMS = 'profile-privacy-and-terms',
  RESET_PASSWORD_REQUEST_FAILURE_AND_EXPIRED = 'reset-password-request-failure-and-expired',
  RESET_PASSWORD_REQUEST_SUCCESS = 'reset-password-request-success',
  RESULTS_PORTAL_ROOT = 'results-portal-root',
  SEND_MAIL = 'send-mail',
  TERM_OF_USER_MODAL = 'term-of-user-modal',
  USER_PROFILE = 'user-profile',
}
export { FragmentNames };
